<template>
  <v-content>
    <div class="staticHero">
      <v-img
        :aspect-ratio="16 / 9"
        max-height="500"
        src="../assets/images/01carousel.jpg"
      >
        <v-row align="end" class="lightbox white--text pa-2 fill-height">
          <v-col>
            <v-container>
              <h2 class="aboutH2">Къща за гости "Никол"</h2>
            </v-container>
          </v-col>
        </v-row>
      </v-img>
    </div>

    <div class="block pa-8">
      <v-container>
        <p class="aboutP">
          Търсите идеалните условия за отдих и туризъм в Хисаря? Мечтаете за
          отпуска сред природата в подножието на Централна Стара планина?
          Търсите гостоприемни домакини и комфортни условия за настаняване? Да,
          къща за гости Никол е отговорът на тези въпроси.
        </p>
        <hr />
        <h3 class="pa-3">
          Къща за гости Никол се намира в град Хисаря, на 50 метра от новата
          колонада и централния площад.
        </h3>
        <h3>
          Къщата разполага с една спалня и една двойна стая със самостоятелни
          санитарни възли.<br />
          Има тераса и кът за отдих. В стаите има безжична интернет връзка и
          телевизори с кабелна телевизия. Предлагаме възможност за паркинг на
          Вашия автомобил в двора. Къщата разполага и с видеонаблюдение.
        </h3>
        <h3>
          Мястото е заобиколено от хотели с минерални басейни и спа процедури -
          базата на ВМА /военен санаториум/ и други.
        </h3>
        <h3>Собственикът е пчелар и предлага чист пчелен мед.</h3>
        <h3 class="aboutH3">Заповядайте!</h3>
      </v-container>
    </div>
    <div class="block pa-2 galleryBlock">
      <h2 class="text-center">Снимки</h2>
      <v-row>
        <v-col
          v-for="item in items"
          :key="item.id"
          class="d-flex child-flex"
          cols="6"
          sm="4"
        >
          <v-img :src="item.src" aspect-ratio="1" class="grey lighten-2">
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-col>
      </v-row>
    </div>
  </v-content>
</template>

<script>
export default {
  name: "About",
  data() {
    return {
      items: [
        {
          id: 1,
          src: require("../assets/images/1.jpg"),
        }, //11 12 10 1
        {
          id: 2,
          src: require("../assets/images/11.jpg"),
        },
        {
          id: 3,
          src: require("../assets/images/12.jpg"),
        },
        {
          id: 4,
          src: require("../assets/images/10.jpg"),
        },
        {
          id: 5,
          src: require("../assets/images/5.jpg"),
        },
        {
          id: 6,
          src: require("../assets/images/6.jpg"),
        },
        {
          id: 7,
          src: require("../assets/images/7.jpg"),
        },
        {
          id: 8,
          src: require("../assets/images/8.jpg"),
        },
        {
          id: 9,
          src: require("../assets/images/4.jpg"),
        },
        {
          id: 10,
          src: require("../assets/images/3.jpg"),
        },
        {
          id: 11,
          src: require("../assets/images/2.jpg"),
        },
        {
          id: 12,
          src: require("../assets/images/9.jpg"),
        },
      ],
    };
  },
};
</script>

